export function getMidnight() {
    let midnight = new Date();
    midnight.setHours(24,0,0,0);
    midnight = new Date(midnight.getTime() + midnight.getTimezoneOffset() * 60 * 1000)
    return midnight;
}